import ClipboardJS from 'clipboard';

$(window).on('load', function() {
   new ClipboardJS('[data-copy-clipboard]', {
         text: function(trigger) {
            return trigger.getAttribute('data-copy-clipboard')!='' ? trigger.getAttribute('data-copy-clipboard') : $(trigger).text();
         }
      }
   );
});
